import { Spinner as CUISpinner } from '@chakra-ui/react';
import React from 'react';

interface SpinnerProps {
  justify: 'container' | 'inline';
}

export const Spinner = (props: SpinnerProps) => {
  const { justify } = props;

  if (justify === 'container') {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <CUISpinner size="lg" />
      </div>
    );
  }

  return <CUISpinner />;
};
